import { render } from "./historial-vue.vue?vue&type=template&id=a576221a&scoped=true"
import script from "./historial-vue.vue?vue&type=script&lang=js"
export * from "./historial-vue.vue?vue&type=script&lang=js"

import "./historial-vue.vue?vue&type=style&index=0&id=a576221a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a576221a"]])

export default __exports__